import { SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLinkR } from './SidebarElements'
import { FaInstagram } from "react-icons/fa";
import './Sidebar.css';

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
        <Icon onClick={toggle}>
            <CloseIcon />
        </Icon>
        <SidebarWrapper>
          <SidebarMenu>
            <SidebarLinkR to="/catering" onClick={toggle}>
              Catering
            </SidebarLinkR>
            <SidebarLinkR to='/event'>
              Eventlokaler
            </SidebarLinkR>
            <SidebarLinkR to="/wedding" offset={60} onClick={toggle}>
              Bröllop
            </SidebarLinkR>
            <SidebarLinkR to="/service" offset={60} onClick={toggle}>
              Service
            </SidebarLinkR>
            <SidebarLinkR to="/decore" offset={60} onClick={toggle}>
              Decor
            </SidebarLinkR>
            <SidebarLinkR to="/cars" offset={60} onClick={toggle}>
              Bilar
            </SidebarLinkR>
            <SidebarLinkR to="/about" offset={60} onClick={toggle}>
              Om Oss
            </SidebarLinkR>
            <div className="sidebar-col">
              <br /> <br />
              <div className="social-links_sidebar">
                <a href='https://www.instagram.com/prestige.stockholm/'><FaInstagram /></a>
              </div>
            </div>
          </SidebarMenu>
        </SidebarWrapper>
    </SidebarContainer>
  )
}

export default Sidebar